import * as React from "react";
import { useGetBusinessVerticalsQuery } from "../services/vertical.service";
import { BusinessVertical } from "../types/vertical";
import SelectData from "./global/SelectData";

const SelectVertical = ({
  onChange,
  sx,
  value,
  error,
  helperText,
  label = "Industry",
  size,
}: {
  onChange: (arg?: number) => void;
  sx?: any;
  value: number;
  error?: boolean;
  helperText?: React.ReactNode;
  label?: string;
  size?: "small" | "medium";
}) => {
  const { data: verticals, isLoading } = useGetBusinessVerticalsQuery();

  return (
    <SelectData
      data={verticals}
      getOptionLabel={(vertical) => vertical.name}
      getOptionValue={(vertical) => vertical.id}
      value={value}
      onChange={(value) => onChange(value as number)}
      label={label}
      placeholder="Search industry..."
      error={error}
      helperText={helperText}
      isLoading={isLoading}
      sx={sx}
    />
  );
};
export default SelectVertical;
